// Contact / upgrade-request recipients. Change here to update every link.
export const CONTACT_EMAILS = ["pascal@pascalbornet.com"];

/** Primary address shown as plain text. */
export const CONTACT_EMAIL = CONTACT_EMAILS[0];

/** mailto: link addressed to the first email, CC'ing the rest.
 *  Note: mailto query params must percent-encode spaces as %20. URLSearchParams
 *  encodes them as "+", which many mail clients (Outlook, Apple Mail) render
 *  literally in the subject — so we hand-build the query with encodeURIComponent. */
export function contactMailto(subject?: string): string {
  const [to, ...cc] = CONTACT_EMAILS;
  const parts: string[] = [];
  if (cc.length) parts.push(`cc=${cc.map(encodeURIComponent).join(",")}`);
  if (subject) parts.push(`subject=${encodeURIComponent(subject)}`);
  const qs = parts.join("&");
  return `mailto:${to}${qs ? `?${qs}` : ""}`;
}
